// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"cf204933","396":"5fa70fb4","453":"c6a96eaa","455":"c8722af0","592":"96a766c3","977":"6e2b2b1b"}[chunkId] + ".chunk.js";
};